<template>
    <ClassroomLayout>
        <WaitingAnimation></WaitingAnimation>
    </ClassroomLayout>
</template>

<script setup>

import ClassroomLayout from "@/components/classroom/ClassroomLayout.vue";
import WaitingAnimation from '@/components/layout/WaitingAnimation';
</script>
